// extracted by mini-css-extract-plugin
export default {"wrapper":"vE8TGCfdE0wWdtv2EBtL","contentWrapper":"Cy6C913WHg40U2bG5zvr","content":"dH5hBC0DuUbubLdFaOc1","contentIcon":"cAMqvX9VzkaHSsvq844Q","popoverVisible":"eTrjerNjxdSS5mQKSQPp"};